<script>
import { swal } from "../../../helpers/handle_error.js";
import {
  required,
  minLength,
  maxLength,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";
import { fileSize, fileType } from "../../../helpers/validators_files";
// import { mapMutations } from "vuex";
import relative_relation from "../../../helpers/list/relative_relation";

export default {
  components: {},
  props: {},
  data() {
    return {
      fields: [],
      attachment_qssam: "",

      //lists
      list_relative_relation: relative_relation,
    };
  },
  validations: {
    fields: {
      $each: {
        name1: { required, minLength: minLength(2), maxLength: maxLength(15) },
        name2: { required, minLength: minLength(2), maxLength: maxLength(15) },
        name3: { required, minLength: minLength(2), maxLength: maxLength(15) },
        name4: { required, minLength: minLength(2), maxLength: maxLength(15) },
        phone1: { required, minLength: minLength(11), maxLength: maxLength(11) },
        relative_relation_id: { required },

        home_adress: { required, minLength: minLength(5), maxLength: maxLength(100) },
        salary: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(1400000),
        },
      },
    },
    attachment_qssam: {
      required,
      fileType: fileType(["application/pdf", "image/jpg", "image/jpeg", "image/png"]),
      fileSize: fileSize(1024 * 1024 * 5),
    },
    form: ["fields", "attachment_qssam"],
  },
  methods: {
    // ...mapMutations("beneficiaries", ["setBeneficiaries"]),

    //  Push the row in form
    AddformDataS() {
      this.fields.push({
        name1: "",
        name2: "",
        name3: "",
        name4: "",
        phone1: "",
        relative_relation_id: "",

        home_adress: "",
        salary: "",
      });
    },
    // Delete the row
    async deleteRowS(index) {
      if (await swal.confirm()) {
        this.fields.splice(index, 1);
      }
    },
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      //add beneficiaries to list in next tab.
      if (isValid) {
        // this.setBeneficiaries(this.fields);
      }
      return isValid;
    },
    chnageFile(e) {
      e = e.target;
      let index = e.getAttribute("data-index");
      this.fields[index][e.id] = e.files.length > 0 ? e.files[0] : null;
    },
  },
  created() {
    this.AddformDataS();
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">مرفق القسام الشرعي للشهيد</h5></div>

      <ul class="li-attachments">
        <li>
          يجب ان يكون المرفق بأحد الصيغ التالية ( pdf .jpg .jpeg .png. ) وبحجم لا يتجاوز (
          5MB ) .
        </li>
      </ul>
      <b-form-group
        class="col-md-12 mb-3"
        label=" مرفق القسام الشرعي :"
        label-for="attachment_qssam"
      >
        <div class="custom_file">
          <b-form-file
            id="attachment_qssam"
            class=""
            :data-index="index"
            placeholder="اختر المرفق"
            accept=".pdf,.jpg,.jpeg,.png"
            v-model="attachment_qssam"
            :class="{ 'is-invalid': $v.attachment_qssam.$error }"
          ></b-form-file>
          <div v-if="$v.attachment_qssam.$error" class="invalid-feedback">
            <span v-if="!$v.attachment_qssam.required">هذا الحقل الزامي</span>
            <span v-if="!$v.attachment_qssam.fileSize"
              >يجب ان لا يتجاوز حجم الملف 5MB</span
            >
            <span v-if="!$v.attachment_qssam.fileType"
              >يجب ان يكون نوع الملف .pdf,.jpg,.jpeg,.png
            </span>
          </div>
        </div>
      </b-form-group>

      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">بيانات المستفيد</h5></div>
      <ul class="li-attachments">
        <li>يجب ادخال المستفيدين المذكورين في القسام الشرعي فقط .</li>
        <li>اذا لم يعرف مقدار الراتب ادخل رقم 0 .</li>
      </ul>

      <form class="repeater" enctype="multipart/form-data">
        <div v-for="(field, index) in $v.fields.$each.$iter" :key="field.id" class="">
          <div class="row">
            <b-form-group class="col-md-3 mb-3" label="الاسم : " label-for="name1">
              <b-form-input
                id="name1"
                type="text"
                placeholder="ادخل الاسم"
                v-model.trim="field.name1.$model"
                :class="{ 'is-invalid': field.name1.$error }"
              ></b-form-input>
              <div v-if="field.name1.$error" class="invalid-feedback">
                <span v-if="!field.name1.required">هذا الحقل الزامي</span>
                <span v-if="!field.name1.minLength"
                  >يجب أن يتكون الاسم من حرفين على الأقل</span
                >
                <span v-if="!field.name1.maxLength"
                  >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group class="col-md-3 mb-3" label="اسم الاب : " label-for="name2">
              <b-form-input
                id="name2"
                type="text"
                placeholder="ادخل اسم الاب"
                v-model.trim="field.name2.$model"
                :class="{ 'is-invalid': field.name2.$error }"
              ></b-form-input>
              <div v-if="field.name2.$error" class="invalid-feedback">
                <span v-if="!field.name2.required">هذا الحقل الزامي</span>
                <span v-if="!field.name2.minLength"
                  >يجب أن يتكون الاسم من حرفين على الأقل</span
                >
                <span v-if="!field.name2.maxLength"
                  >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group class="col-md-3 mb-3" label="اسم الجد : " label-for="name3">
              <b-form-input
                id="name3"
                type="text"
                placeholder="ادخل اسم الجد"
                v-model.trim="field.name3.$model"
                :class="{ 'is-invalid': field.name3.$error }"
              ></b-form-input>
              <div v-if="field.name3.$error" class="invalid-feedback">
                <span v-if="!field.name3.required">هذا الحقل الزامي</span>
                <span v-if="!field.name3.minLength"
                  >يجب أن يتكون الاسم من حرفين على الأقل</span
                >
                <span v-if="!field.name3.maxLength"
                  >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group class="col-md-3 mb-3" label="اسم اب الجد : " label-for="name4">
              <b-form-input
                id="name4"
                type="text"
                placeholder="ادخل اسم اب الجد"
                v-model.trim="field.name4.$model"
                :class="{ 'is-invalid': field.name4.$error }"
              ></b-form-input>
              <div v-if="field.name4.$error" class="invalid-feedback">
                <span v-if="!field.name4.required">هذا الحقل الزامي</span>
                <span v-if="!field.name4.minLength"
                  >يجب أن يتكون الاسم من حرفين على الأقل</span
                >
                <span v-if="!field.name4.maxLength"
                  >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group
              class="col-md-3 mb-3"
              label=" صلة القرابه : "
              label-for="relative_relation_id"
            >
              <select
                class="form-control"
                id="relative_relation_id"
                v-model.trim="field.relative_relation_id.$model"
                :class="{ 'is-invalid': field.relative_relation_id.$error }"
              >
                <option value="">اختر صلة القرابه</option>
                <option
                  v-for="relative_relation in list_relative_relation"
                  :value="relative_relation.id"
                  :key="relative_relation.id"
                >
                  {{ relative_relation.name }}
                </option>
              </select>
              <div v-if="field.relative_relation_id.$error" class="invalid-feedback">
                <span v-if="!field.relative_relation_id.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>
            <b-form-group class="col-md-3 mb-3" label=" رقم الهاتف : " label-for="phone1">
              <b-form-input
                id="phone1"
                type="number"
                placeholder="ادخل رقم الهاتف"
                v-model.trim="field.phone1.$model"
                :class="{ 'is-invalid': field.phone1.$error }"
              ></b-form-input>
              <div v-if="field.phone1.$error" class="invalid-feedback">
                <span v-if="!field.phone1.required">هذا الحقل الزامي</span>
                <span v-if="!field.phone1.minLength"
                  >يجب أن يتكون رقم الهاتف من 11 رقم على الأقل</span
                >
                <span v-if="!field.phone1.maxLength"
                  >يجب أن يتكون رقم الهاتف من 11 رقم على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-3 mb-3"
              label="عنوان السكن الحالي : "
              label-for="home_adress"
            >
              <b-form-input
                id="home_adress"
                type="text"
                placeholder="ادخل عنوان السكن الحالي"
                v-model.trim="field.home_adress.$model"
                :class="{ 'is-invalid': field.home_adress.$error }"
              ></b-form-input>
              <div v-if="field.home_adress.$error" class="invalid-feedback">
                <span v-if="!field.home_adress.required">هذا الحقل الزامي</span>
                <span v-if="!field.home_adress.minLength"
                  >يجب أن يتكون عنوان السكن الحالي من 5 احرف على الأقل</span
                >
                <span v-if="!field.home_adress.maxLength"
                  >يجب أن يتكون عنوان السكن الحالي من 100 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-3 mb-3"
              label=" مقدار الراتب التقاعدي : "
              label-for="salary"
            >
              <b-form-input
                id="salary"
                type="number"
                placeholder="ادخل مقدار الراتب التقاعدي"
                v-model.trim="field.salary.$model"
                :class="{ 'is-invalid': field.salary.$error }"
              ></b-form-input>
              <div v-if="field.salary.$error" class="invalid-feedback">
                <span v-if="!field.salary.required">هذا الحقل الزامي</span>
                <span v-if="!field.salary.minValue"
                  >يجب أن يكون مقدار الراتب 0 على الأقل</span
                >
                <span v-if="!field.salary.maxValue"
                  >يجب أن يكون مقدار الراتب 1400000 على الاكثر</span
                >
              </div>
            </b-form-group>
          </div>

          <div class="row">
            <b-form-group
              class="col-md-12 mb-3"
              label=" حذف :"
              label-for=""
              v-if="fields.length > 1"
            >
              <div class="d-grid">
                <button
                  type="button"
                  class="btn btn-danger btn-block"
                  @click="deleteRowS(index)"
                >
                  <i class="bx bx-trash font-size-16 align-middle"></i>
                </button>
              </div>
            </b-form-group>

            <div class="col-lg-12"><hr class="mt-0" /></div>
          </div>
        </div>
        <input
          type="button"
          class="btn btn-primary mt-3 mb-3 mt-lg-0"
          style="width: 100%"
          value="اضافة مستفيد اخر"
          @click="AddformDataS"
        />
      </form>
    </div>
  </div>
  <!-- end page title -->
</template>
